import { render, staticRenderFns } from "./projectConstructionCG.vue?vue&type=template&id=d18f5df4"
import script from "./projectConstructionCG.vue?vue&type=script&lang=js"
export * from "./projectConstructionCG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports